export default __webpack_public_path__ + "static/media/pen.8c15145b.svg";